import {TelefoneCliente} from '../comum/modelos/telefone-cliente';
import {EnderecoCliente} from '../comum/modelos/endereco-cliente';
import {Cliente} from '../comum/modelos/cliente';
import {Response} from '@angular/http';
import {SettingsService} from './../settings.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { AreaCliente } from '../comum/modelos/area-cliente';

@Injectable()
export class ClienteService {
  private _host: string;

  clientes: Cliente[];

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/clientes/';
  }

  removerCliente(clientes: Cliente[], cliente: Cliente): void {
    const index = clientes.indexOf(cliente);
    clientes.splice(index, 1);
  }

  obterClientesHttp(): Observable<Cliente[]> {
    return this._http.get(this._host)
      .catch(this.handleError);
  }

  obterClientePorIdHttp(id: number): Observable<Cliente> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  cadastrarClienteHttp(cliente: Cliente, logo: File): Observable<HttpResponse<Cliente>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', logo);
    formdata.append('cliente', new Blob([JSON.stringify(cliente)], {
      type: 'application/json'
    }));
    return this._http
      .post(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarClienteHttp(cliente: Cliente, logo: File): Observable<HttpResponse<Cliente>> {
    const formdata: FormData = new FormData();
    formdata.append('imagem', logo);
    formdata.append('cliente', new Blob([JSON.stringify(cliente)], {
      type: 'application/json'
    }));
    return this._http
      .put(this._host, formdata, {
        observe: 'response'
      })
      .catch(this.handleError);

  }

  removerClienteHttp(idCliente: number): Observable<HttpResponse<Cliente>> {
    return this._http
      .delete(this._host + idCliente, {
        observe: 'response'
      }).catch(this.handleError);
  }

  cadastrarTelefonesClienteHttp(telefoneCliente: TelefoneCliente[]): Observable<HttpResponse<TelefoneCliente[]>> {
    return this._http
      .post(this._host + 'telefone-cliente/', telefoneCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarTelefonesClienteHttp(telefonesCliente: TelefoneCliente[]): Observable<HttpResponse<TelefoneCliente[]>> {
    return this._http
      .put(this._host + 'telefone-cliente/', telefonesCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerTelefonesClienteHttp(telefonesCliente: TelefoneCliente[]): Observable<HttpResponse<TelefoneCliente[]>> {
    return this._http
      .patch(this._host + 'telefone-cliente/', telefonesCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarEnderecosClienteHttp(enderecoCliente: EnderecoCliente[]): Observable<HttpResponse<EnderecoCliente[]>> {
    return this._http
      .post(this._host + 'endereco-cliente/', enderecoCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarEnderecosClienteHttp(enderecoCliente: EnderecoCliente[]): Observable<HttpResponse<EnderecoCliente[]>> {
    return this._http
      .put(this._host + 'endereco-cliente/', enderecoCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerEnderecosClienteHttp(enderecoCliente: EnderecoCliente[]): Observable<HttpResponse<EnderecoCliente[]>> {
    return this._http
      .patch(this._host + 'endereco-cliente/', enderecoCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarAreasClienteHttp(areasCliente: AreaCliente[]): Observable<HttpResponse<AreaCliente[]>> {
    return this._http
      .post(this._host + 'area-cliente/', areasCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarAreasClienteHttp(areasCliente: AreaCliente[]): Observable<HttpResponse<AreaCliente[]>> {
    return this._http
      .put(this._host + 'area-cliente/', areasCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerAreasClienteHttp(areasCliente: AreaCliente[]): Observable<HttpResponse<AreaCliente[]>> {
    return this._http
      .patch(this._host + 'area-cliente/', areasCliente, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterAreasClienteHttp(id: number): Observable<AreaCliente[]> {
    return this._http.get(this._host + 'area-cliente/' + id)
      .catch(this.handleError);
  }

  obterAreasUsuarioHttp(id: number): Observable<AreaCliente[]> {
    return this._http.get(this._host + 'area-cliente-usuario/' + id)
      .catch(this.handleError);
  }

  private handleError(error: Response) {

    console.error(error);

    return Observable.throw(error.json().error || 'Server error');

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/cliente/cliente.service.ts